export enum StructureSummaryNameEnum {
  "木造" = "木造",
  "鉄骨造" = "鉄骨造",
  "RC造" = "RC造",
  "CB造" = "CB造",
  "その他" = "その他"
}
